import { render, staticRenderFns } from "./TableHeaderCustom.vue?vue&type=template&id=21f67b4e&scoped=true&"
import script from "./TableHeaderCustom.vue?vue&type=script&lang=js&"
export * from "./TableHeaderCustom.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaderCustom.vue?vue&type=style&index=0&id=21f67b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f67b4e",
  null
  
)

export default component.exports